import React from "react";
import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader } from "@mui/material";

export const GoogleChat: React.FC = () => {
  const addToGoogleChatLink =
    "https://scribehow.com/page/Awareness_Setup_Google_Chat__0IWBGno6TcqeAaCA3X8NVw";
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader title={t("Google Chat Configuration")} />
      <CardContent>
        <div>{t("Enable Alex to reach to your team via Google Chat.")}</div>
        <br />
        <div>
          <a href={addToGoogleChatLink} target="_blank" rel="noreferrer">
            <img
              alt="Add to Google Chat"
              height="30"
              width="30"
              src="https://storage.googleapis.com/mantrams-learning/Google_Chat_icon_(2023).svg.png"
            />
            <span style={{ marginLeft: "10px", verticalAlign: "middle" }}>
              {t("Add to Google Chat")}
            </span>
          </a>
        </div>
      </CardContent>
    </Card>
  );
};
